(function(){
  var WA = '573161283772';   /* WhatsApp real de Presura */
  var HANDLE = 'cafetera-espresso-portatil-3-en-1';   /* ahora surtido por Mastershop */

  function listo(fn){
    if(document.readyState!=='loading'){fn();}
    else{document.addEventListener('DOMContentLoaded',fn);}
  }

  function n(){
    var c=document.getElementById('cartCount');
    return c?(parseInt(c.textContent,10)||0):0;
  }

  /* 0 - todos los enlaces de WhatsApp apuntan al numero real */
  function whatsapp(){
    function arreglar(a){
      if(!a || !a.href) return;
      var i=a.href.indexOf('wa.me/');
      if(i<0) return;
      var cola=a.href.slice(i+6);
      var corte=cola.length;
      for(var k=0;k<cola.length;k++){
        var ch=cola.charAt(k);
        if(ch<'0'||ch>'9'){corte=k;break;}
      }
      a.href=a.href.slice(0,i)+'wa.me/'+WA+cola.slice(corte);
    }
    [].slice.call(document.querySelectorAll('a[href*="wa.me/"]')).forEach(arreglar);
    document.addEventListener('click', function(e){
      var a = e.target && e.target.closest ? e.target.closest('a[href*="wa.me/"]') : null;
      arreglar(a);
    }, true);
  }

  /* 1 - cada boton de compra agrega el producto y abre el carrito */
  function botones(){
    var add=document.getElementById('addBtn');
    if(!add||!document.getElementById('cartCount')) return;
    var sel='[data-pick], .mobilemenu a.mcta';
    [].slice.call(document.querySelectorAll(sel)).forEach(function(b){
      b.addEventListener('click',function(e){
        e.preventDefault();
        if(n()===0){add.click();}
        else{var cb=document.getElementById('cartBtn'); if(cb) cb.click();}
      });
    });
  }

  /* 1.5 - LA VARIANTE SE PREGUNTA EN VIVO.
     La pagina puede estar guardada en el navegador del cliente desde hace dias,
     y el proveedor recrea la variante cada vez que sincroniza. Por eso, en el
     momento exacto del clic, le preguntamos a Shopify cual es la variante
     vigente en vez de confiar en la que venia escrita en la pagina. Si la
     consulta falla, usamos la que trae la pagina: nunca se queda sin respuesta. */
  function varianteViva(){
    var pagina = String(window.PRESURA_VARIANT||'');
    if(!window.fetch || !window.Promise){
      return { then: function(f){ f(pagina); return this; } };
    }
    return fetch('/products/'+HANDLE+'.js', {
      credentials:'same-origin',
      cache:'no-store',
      headers:{'Accept':'application/json'}
    }).then(function(r){
      if(!r || !r.ok) throw new Error('producto');
      return r.json();
    }).then(function(p){
      if(!p || !p.variants || !p.variants.length) return pagina;
      var elegida=null;
      for(var i=0;i<p.variants.length;i++){
        if(p.variants[i] && p.variants[i].available){ elegida=p.variants[i].id; break; }
      }
      if(!elegida) elegida=p.variants[0].id;
      return elegida ? String(elegida) : pagina;
    }).catch(function(){ return pagina; });
  }

  /* 2 - dos botones: contra entrega y pago inmediato.
        Los dos arman el carrito de Shopify por detras y entran DIRECTO al
        formulario del checkout. La pagina /cart de Horizon nunca se ve. */
  function pagar(){
    var pb=document.getElementById('payBtn');
    var sub=document.getElementById('subtotal');
    if(!pb||!sub) return;
    pb.style.display='none';

    var caja=document.createElement('div');
    caja.className='paybox';
    caja.innerHTML=
      '<button class="btn" id="btnCOD"><span class="b1">Pedir contra entrega</span>'+
        '<span class="b2">Pagas al recibir &middot; <span data-monto></span></span></button>'+
      '<p class="paynote">Llenas tus datos de env&iacute;o y en la secci&oacute;n <b>Pago</b> eliges '+
      '<b>&laquo;Pago contra entrega&raquo;</b>. Le pagas en efectivo al mensajero.</p>'+
      '<button class="btn btn-alt" id="btnYA"><span class="b1">Pagar ahora</span>'+
        '<span class="b2">Tarjeta, PSE, Daviplata o PayPal &middot; <span data-monto></span></span></button>'+
      '<p class="paynote">Llenas tus datos de env&iacute;o y en la secci&oacute;n <b>Pago</b> eliges '+
      'tarjeta, PSE, Daviplata o PayPal.</p>';
    pb.parentNode.insertBefore(caja,pb.nextSibling);

    function montos(){
      var t=sub.textContent.trim();
      [].slice.call(caja.querySelectorAll('[data-monto]')).forEach(function(e){e.textContent=t;});
    }
    montos();
    new MutationObserver(montos).observe(sub,{childList:true,characterData:true,subtree:true});

    function ir(metodo,boton){
      var q=n();
      if(q===0) return;

      /* El titulo del boton NO se toca: solo la linea de abajo avisa que va en camino.
         Y si algo falla, todo vuelve a su sitio a los 12 segundos. */
      var b2=boton.querySelector('.b2');
      var original = b2 ? b2.innerHTML : '';
      if(b2) b2.innerHTML='Te llevamos al pago&hellip;';
      boton.setAttribute('aria-busy','true');
      caja.style.pointerEvents='none';

      var reponer=setTimeout(function(){
        if(b2) b2.innerHTML=original;
        boton.removeAttribute('aria-busy');
        caja.style.pointerEvents='';
        montos();
      },12000);

      function seguir(vid){
        vid=String(vid||'');
        if(!vid){ return; }

        /* plan B: formulario clasico. return_to manda al checkout sin pasar por /cart */
        function formulario(){
          clearTimeout(reponer);
          var f=document.createElement('form');
          f.method='post';
          f.action='/cart/add';
          f.style.display='none';
          function campo(k,v){
            var i=document.createElement('input');
            i.type='hidden'; i.name=k; i.value=v;
            f.appendChild(i);
          }
          campo('id',vid);
          campo('quantity',String(q));
          campo('properties[Metodo]',metodo);
          campo('return_to','/checkout');
          document.body.appendChild(f);
          f.submit();
        }

        if(!window.fetch){ formulario(); return; }

        fetch('/cart/clear.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          credentials:'same-origin'
        }).then(function(){
          return fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            credentials:'same-origin',
            body:JSON.stringify({items:[{id:Number(vid),quantity:q,properties:{'Metodo':metodo}}]})
          });
        }).then(function(r){
          if(!r || !r.ok) throw new Error('add');
          clearTimeout(reponer);
          window.location.href='/checkout';
        }).catch(function(){ formulario(); });
      }

      varianteViva().then(seguir);
    }

    document.getElementById('btnCOD').addEventListener('click',function(e){
      e.preventDefault(); ir('Contra entrega',this);
    });
    document.getElementById('btnYA').addEventListener('click',function(e){
      e.preventDefault(); ir('Pago anticipado',this);
    });
  }

  /* 3 - firma PRESURA de borde a borde al cerrar el footer */
  function firma(){
    var pie=document.querySelector('#presura-page footer');
    if(!pie||pie.querySelector('.fmark')) return;
    var NS='http://www.w3.org/2000/svg';
    var svg=document.createElementNS(NS,'svg');
    svg.setAttribute('class','fmark');
    svg.setAttribute('viewBox','0 0 1000 143');
    svg.setAttribute('aria-hidden','true');
    svg.setAttribute('focusable','false');
    var t=document.createElementNS(NS,'text');
    t.setAttribute('x','0'); t.setAttribute('y','143');
    t.setAttribute('textLength','1000');
    t.setAttribute('lengthAdjust','spacing');
    t.setAttribute('font-family','Archivo, system-ui, sans-serif');
    t.setAttribute('font-weight','900');
    t.setAttribute('font-size','217');
    t.setAttribute('fill','currentColor');
    t.textContent='PRESURA';
    svg.appendChild(t);
    pie.appendChild(svg);
  }

  listo(function(){ whatsapp(); botones(); pagar(); firma(); });
})();
